import styles from "./checkoutstepper.module.css";

const CheckoutStepper = ({ currentStep = 1 }) => {
  const steps = [
    {
      number: 1,
      label: "Delivery",
    },
    {
      number: 2,
      label: "Payment",
    },
  ];

  return (
    <div className={styles.checkoutStepper}>
      {steps.map((step, index) => {
        const completed = currentStep > step.number;
        const active = currentStep === step.number;

        return (
          <div
            key={step.number}
            className={styles.stepWrapper}
          >

            <div className={styles.stepItem}>

              <div
                className={`
                  ${styles.stepCircle}
                  ${completed ? styles.completed : ""}
                  ${active ? styles.active : ""}
                `}
              >
                {completed ? "✓" : step.number}
              </div>

              <span
                className={`
                  ${styles.stepLabel}
                  ${completed ? styles.completedLabel : ""}
                  ${active ? styles.activeLabel : ""}
                `}
              >
                {step.label}
              </span>

            </div>

            {index < steps.length - 1 && (
              <div
                className={`
                  ${styles.stepLine}
                  ${completed ? styles.completedLine : ""}
                `}
              />
            )}

          </div>
        );
      })}
    </div>
  );
};

export default CheckoutStepper;